export enum ReferenceLineType {
	VALUE = 'value',
	DYNAMIC = 'dynamic'
}
